import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap-trial/ScrollSmoother"
import * as Menu from "./menu"
import * as Collapsibles from "./collapsibles"

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);


let parallax = document.querySelector('#home-header')

if (parallax) {
	gsap.to("[data-speed]", {
		y: (i, el) => (-1 * parseFloat(el.getAttribute("data-speed"))) * (parallax.offsetHeight / 3),
		ease: "none",
		scrollTrigger: {
			trigger: parallax,
			invalidateOnRefresh: true,
			scrub: 0,
			// markers: true,
			start: 'center bottom'
		}
	});
}

(function ($) {
	Menu.init()

	$(document).foundation();

	$(function () {
		let $collapsibles = $('.collapsibles-trigger')
			, $video = $('#video')
			, video = $video.get(0)
			, paused = false

		const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);

		Collapsibles.init($collapsibles, () => {
			paused = !paused

			let isVideoSectionOpen = $('#video-section').find('article').hasClass('open')

			console.log(isVideoSectionOpen);
			console.log(`${isVideoPlaying}}`);


			if (video.readyState > 2 && isVideoSectionOpen) {
				$video.get(0).play()
				window.location.href = "#video-presentation"
			} else {
				$video.get(0).pause()
			}
		})

		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();

		// Makes sure last grid item floats left
		$('.archive-grid .columns').last().addClass('end');

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
			if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
				$(this).wrap("<div class='widescreen flex-video'/>");
			} else {
				$(this).wrap("<div class='flex-video'/>");
			}
		});

		$(window).scroll(function () {
			if ($(window).scrollTop() > 100) {
				$('div.scrolltop').css('visibility', 'visible');
				$('div.scrolltop').css('opacity', '1');
			} else {
				$('div.scrolltop').css('visibility', 'hidden');
				$('div.scrolltop').css('opacity', '0');
			}
		});

		$('div.scrolltop').click(function () {
			$("html, body").animate({ scrollTop: 0 }, 450);
			return false;
		});
	});
})(jQuery)